import casino1 from "../assets/images/17627666895880894.webp";
import casino2 from "../assets/images/17627666966773371.webp";
import casino3 from "../assets/images/17627667037947034.webp";
import casino4 from "../assets/images/17627667207446881.webp";
import casino5 from "../assets/images/17627667265483610.webp";
import casino6 from "../assets/images/17627667335828371.webp";
import casino7 from "../assets/images/17627667396466553.webp";
import casino8 from "../assets/images/17627667559465232.webp";
import casino9 from "../assets/images/17627667617577382.webp";
import casino10 from "../assets/images/17627667768757066.webp";
import casino11 from "../assets/images/17627667959015593.webp";
import casino12 from "../assets/images/17627667473323418.webp";
import casino13 from "../assets/images/17627667697736998.webp";
import casino14 from "../assets/images/17627668019132332.webp";

// Home / In-play / Sports — custom thumb strip (distinct from CASINO_PROVIDER_IMAGES imports above)
import thumbCasino1 from "../assets/images/17741827173955390.gif";
import thumbCasino2 from "../assets/images/17753849247758330.gif";
import thumbCasino3 from "../assets/images/17721100879567338.gif";
import thumbCasino4 from "../assets/images/17753226434465471.gif";
import thumbCasino5 from "../assets/images/17721101123183452.gif";
import thumbCasino6 from "../assets/images/17721100327328503.gif";
import thumbCasino7 from "../assets/images/17721100393698204.gif";
import thumbCasino8 from "../assets/images/17721100468285011.gif";
import thumbCasino9 from "../assets/images/pump.webp";
import thumbCasino10 from "../assets/images/FANTASY_1774787946393.346_1774959811521.3718.png";
import thumbCasino11 from "../assets/images/bollywood_casino.webp";
import thumbCasino12 from "../assets/images/queen.webp";
import thumbCasino13 from "../assets/images/evo_xxxtremelightningroulette.webp";
import thumbCasino14 from "../assets/images/sbe_aviator1.jpg";
import thumbCasino15 from "../assets/images/bbb.webp";
import thumbCasino16 from "../assets/images/dt2.webp";
import thumbCasino17 from "../assets/images/dt_mac88.webp";
import thumbCasino18 from "../assets/images/dtl_20_20.webp";
import thumbCasino19 from "../assets/images/dt_1day.webp";
import thumbCasino20 from "../assets/images/baccarat_one_day.webp";
import thumbCasino21 from "../assets/images/baccarat_mac88.webp";
import thumbCasino22 from "../assets/images/29b.webp";
import thumbCasino23 from "../assets/images/sicbo_mac88.webp";
import thumbCasino24 from "../assets/images/roulette_mac88.webp";
import thumbCasino25 from "../assets/images/20_20_poker.webp";
import thumbCasino26 from "../assets/images/poker_1_day.webp";
import thumbCasino27 from "../assets/images/lucky_7.webp";
import thumbCasino28 from "../assets/images/andar_bahar.webp";
import thumbCasino29 from "../assets/images/tp1d.webp";
import thumbCasino30 from "../assets/images/teenpatti_test.webp";
import thumbCasino31 from "../assets/images/2_cards_teenpatti.webp";
import thumbCasino32 from "../assets/images/muflis_teenpati.webp";

import newLaunch1 from "../assets/images/17627668868809452.webp";
import newLaunch2 from "../assets/images/17627669861592174.webp";
import newLaunch3 from "../assets/images/17728789629620161.png";
import newLaunch4 from "../assets/images/17627669074910958.webp";
import newLaunch5 from "../assets/images/17650471775313323.png";
import newLaunch6 from "../assets/images/17627669201123954.webp";
import newLaunch7 from "../assets/images/17650471925630440.png";
import newLaunch8 from "../assets/images/17650472072967902.png";
import newLaunch9 from "../assets/images/17627669432196473.webp";
import newLaunch10 from "../assets/images/17730903096565252.png";
import newLaunch11 from "../assets/images/17728796639425692.png";
import newLaunch12 from "../assets/images/17704078866129468.png";

export const THUMB_IMAGES = [
  {
    src: thumbCasino1,
    path: "/casino?category=EZUGI&providerCode=EZU&subCategory=ALL",
  },
  // { src: thumbCasino2, hcDiv: true, path: "" },
  // { src: thumbCasino3, hcDiv: true, path: "" },
  {
    src: thumbCasino4,
    game_id: "151187",
    game_name: "Marble Run",
    category: "Virtual",
    provider_name: "MAC88",
    sub_provider_name: "Mac88 Gaming Virtual",
    status: "ACTIVE",
    url_thumb: "https://cdn.mac88.com/mac88/marblerun.webp",
    game_code: "MAC88-CMR101",
  },
  // { src: thumbCasino5, hcDiv: true, path: "" },
  {
    src: thumbCasino6,
    path: "/casino?category=ALL&providerCode=MAC88&subCategory=Aviator+X",
  },
  {
    src: thumbCasino7,
    path: "/casino?category=ALL&providerCode=MAC88&subCategory=Mines",
  },
  {
    src: thumbCasino8,
    path: "/casino?category=ALL&providerCode=MAC88&subCategory=Color+game",
  },
  {
    src: thumbCasino9,
    game_id: "151162",
    game_name: "Pump",
    category: "Virtual",
    provider_name: "MAC88",
    sub_provider_name: "Mac88 Gaming Virtual",
    status: "ACTIVE",
    url_thumb: "https://cdn.mac88.com/mac88/pump.webp",
    game_code: "MAC88-CPUM101",
  },
  // { src: thumbCasino10 },
  {
    src: thumbCasino11,
    game_id: "150623",
    game_name: "Bollywood Casino",
    category: "Live",
    provider_name: "MAC88",
    sub_provider_name: "MAC Excite",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/macexcite/bc.webp",
    game_code: "ME-BBOC102",
  },
  {
    src: thumbCasino12,
    game_id: "150016",
    game_name: "Queen Race",
    category: "Live Dealer",
    provider_name: "MAC88",
    sub_provider_name: "Mac88 Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/mac88/queen.webp",
    game_code: "MAC88-YQR102",
  },
  {
    src: thumbCasino13,
    game_id: "151180",
    game_name: "VR Lightning Roulette",
    category: "Virtual",
    provider_name: "MAC88",
    sub_provider_name: "Mac88 Gaming Virtual",
    status: "ACTIVE",
    url_thumb: "https://cdn.mac88.com/mac88/VLRT.webp",
    game_code: "MAC88-LRO101",
  },
  {
    src: thumbCasino14,
    game_id: "151027",
    game_name: "Aviator X",
    category: "Virtual",
    provider_name: "MAC88",
    sub_provider_name: "Fun Games",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/monk88/aviatorx.webp",
    game_code: "MAC88-CAV101-VR",
  },
  {
    src: thumbCasino15,
    game_id: "151083",
    game_name: "Ball by Ball VR",
    category: "Virtual",
    provider_name: "MAC88",
    sub_provider_name: "Mac88 Gaming Virtual",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/mac88/bbb.webp",
    game_code: "MAC88-BB101",
  },
  {
    src: thumbCasino16,
    game_id: "150067",
    game_name: "Dragon Tiger 2",
    category: "Live",
    provider_name: "MAC88",
    sub_provider_name: "Mac88 Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/mac88/dt2.webp",
    game_code: "MAC88-DT2101",
  },
  {
    src: thumbCasino17,
    game_id: "150001",
    game_name: "Dragon Tiger",
    category: "Live Dealer",
    provider_name: "MAC88",
    sub_provider_name: "Mac88 Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/mac88/dt_mac88.webp",
    game_code: "MAC88-YDT102",
  },
  {
    src: thumbCasino18,
    game_id: "150013",
    game_name: "Dragon Tiger Lion",
    category: "Live Dealer",
    provider_name: "MAC88",
    sub_provider_name: "Mac88 Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/mac88/dtl_20_20.webp",
    game_code: "MAC88-YDTL101",
  },
  {
    src: thumbCasino19,
    game_id: "150036",
    game_name: "1 Day Dragon Tiger",
    category: "Live Dealer",
    provider_name: "MAC88",
    sub_provider_name: "Mac88 Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/mac88/dt_1day.webp",
    game_code: "MAC88-X1DT101",
  },
  {
    src: thumbCasino20,
    game_id: "150601",
    game_name: "Baccarat",
    category: "Live",
    provider_name: "MAC88",
    sub_provider_name: "MAC Excite",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/macexcite/baccarat.webp",
    game_code: "ME-BBAC101",
  },
  // {
  //   src: thumbCasino21,
  //   game_id: "150601",
  //   game_name: "Baccarat",
  //   category: "Live",
  //   provider_name: "MAC88",
  //   sub_provider_name: "MAC Excite",
  //   status: "ACTIVE",
  //   url_thumb: "https://cdn.dreamdelhi.com/macexcite/baccarat.webp",
  //   game_code: "ME-BBAC101",
  // },
  {
    src: thumbCasino22,
    game_id: "150026",
    game_name: "29 Baccarat",
    category: "Live",
    provider_name: "MAC88",
    sub_provider_name: "Mac88 Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/mac88/29b.webp",
    game_code: "MAC88-X29BC101",
  },
  {
    src: thumbCasino23,
    game_id: "150003",
    game_name: "Sic Bo",
    category: "Live Dealer",
    provider_name: "MAC88",
    sub_provider_name: "Mac88 Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/mac88/sicbo_mac88.webp",
    game_code: "MAC88-XSB101",
  },
  {
    src: thumbCasino24,
    game_id: "150004",
    game_name: "Roulette",
    category: "Live Dealer",
    provider_name: "MAC88",
    sub_provider_name: "Mac88 Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/mac88/roulette_mac88.webp",
    game_code: "MAC88-XRT101",
  },
  {
    src: thumbCasino25,
    game_id: "150005",
    game_name: "Poker 20-20",
    category: "Live Dealer",
    provider_name: "MAC88",
    sub_provider_name: "Mac88 Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/mac88/20_20_poker.webp",
    game_code: "MAC88-XPOK101",
  },
  {
    src: thumbCasino26,
    game_id: "150032",
    game_name: "Poker 1-Day",
    category: "Live Dealer",
    provider_name: "MAC88",
    sub_provider_name: "Mac88 Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/mac88/poker_1_day.webp",
    game_code: "MAC88-Y1POK101",
  },
  {
    src: thumbCasino27,
    game_id: "150605",
    game_name: "Lucky 7",
    category: "Live",
    provider_name: "MAC88",
    sub_provider_name: "MAC Excite",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/macexcite/l7.webp",
    game_code: "ME-BLK7101",
  },
  {
    src: thumbCasino28,
    game_id: "150606",
    game_name: "Andar Bahar",
    category: "Live",
    provider_name: "MAC88",
    sub_provider_name: "MAC Excite",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/macexcite/ab.webp",
    game_code: "ME-BAB101",
  },
  {
    src: thumbCasino29,
    game_id: "150607",
    game_name: "Teenpatti One Day",
    category: "Live",
    provider_name: "MAC88",
    sub_provider_name: "MAC Excite",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/macexcite/tp1d.webp",
    game_code: "ME-B1TP101",
  },
  {
    src: thumbCasino30,
    game_id: "150617",
    game_name: "Test Teenpatti",
    category: "Live",
    provider_name: "MAC88",
    sub_provider_name: "MAC Excite",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/macexcite/ttp.webp",
    game_code: "ME-BTTP102",
  },
  {
    src: thumbCasino31,
    game_id: "150028",
    game_name: "Two Card Teenpatti",
    category: "Live Dealer",
    provider_name: "MAC88",
    sub_provider_name: "Mac88 Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/mac88/2_cards_teenpatti.webp",
    game_code: "MAC88-Y12TP101",
  },
  {
    src: thumbCasino32,
    game_id: "150030",
    game_name: "Muflis Teenpatti One Day",
    category: "Live Dealer",
    provider_name: "MAC88",
    sub_provider_name: "Mac88 Gaming",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamdelhi.com/mac88/muflis_teenpati.webp",
    game_code: "MAC88-Y1MTP101",
  },
];

export const BANNER_SLIDES = [
  {
    src: newLaunch1,
    alt: "Packs",
    gameId: "151164",
    gameCode: "MAC88-COPK101",
    gameName: "Packs",
    urlThumb: newLaunch1,
    category: "Virtual",
    providerName: "MAC88",
    subProviderName: "Mac88 Gaming Virtual",
    superProviderName: "",
    providerTag: "",
    priority: 0,
    game_id: "151164",
    game_name: "Packs",
    provider_name: "MAC88",
    sub_provider_name: "Mac88 Gaming Virtual",
    status: "ACTIVE",
    url_thumb: newLaunch1,
    game_code: "MAC88-COPK101",
  },
  {
    src: newLaunch2,
    alt: "Naughty Button",
    gameId: "151165",
    gameCode: "MAC88-CNB101",
    gameName: "Naughty Button",
    urlThumb: newLaunch2,
    category: "Virtual",
    providerName: "MAC88",
    subProviderName: "Mac88 Gaming Virtual",
    superProviderName: "",
    providerTag: "",
    priority: 0,
    game_id: "151165",
    game_name: "Naughty Button",
    provider_name: "MAC88",
    sub_provider_name: "Mac88 Gaming Virtual",
    status: "ACTIVE",
    url_thumb: newLaunch2,
    game_code: "MAC88-CNB101",
  },
  {
    src: newLaunch3,
    alt: "Instant Rummy",
    gameId: "151181",
    gameCode: "MAC88-IRY101",
    gameName: "Instant Rummy",
    urlThumb: newLaunch3,
    category: "Virtual",
    providerName: "MAC88",
    subProviderName: "Mac88 Gaming Virtual",
    superProviderName: "",
    providerTag: "",
    priority: 0,
    game_code: "MAC88-IRY101",
    game_name: "Instant Rummy",
    provider_name: "MAC88",
    sub_provider_name: "Mac88 Gaming Virtual",
    status: "ACTIVE",
    url_thumb: newLaunch3,
  },
  {
    src: newLaunch4,
    alt: "Jhandi Munda",
    gameId: "151133",
    gameCode: "MAC88-JM101",
    gameName: "Jhandi Munda",
    urlThumb: newLaunch4,
    category: "Virtual",
    providerName: "MAC88",
    subProviderName: "Mac88 Gaming Virtual",
    superProviderName: "",
    providerTag: "",
    priority: 0,
    game_id: "151133",
    game_name: "Jhandi Munda",
    provider_name: "MAC88",
    sub_provider_name: "Mac88 Gaming Virtual",
    status: "ACTIVE",
    url_thumb: newLaunch4,
    game_code: "MAC88-JM101",
  },
  {
    src: newLaunch5,
    alt: "The Voice",
    gameId: "151178",
    gameCode: "MAC88-CVOI101",
    gameName: "The Voice",
    urlThumb: newLaunch5,
    category: "Virtual",
    providerName: "MAC88",
    subProviderName: "Mac88 Gaming Virtual",
    superProviderName: "",
    providerTag: "",
    priority: 0,
    game_id: "151178",
    game_name: "The Voice",
    provider_name: "MAC88",
    sub_provider_name: "Mac88 Gaming Virtual",
    status: "ACTIVE",
    url_thumb: newLaunch5,
    game_code: "MAC88-CVOI101",
  },
  {
    src: newLaunch6,
    alt: "Twistx",
    gameId: "151080",
    gameCode: "MAC88-CVO101",
    gameName: "Vortex",
    urlThumb: newLaunch6,
    category: "Slot Games",
    providerName: "MAC88",
    subProviderName: "Mac88 Gaming Virtual",
    superProviderName: "",
    providerTag: "",
    priority: 0,
    game_id: "151080",
    game_name: "Vortex",
    provider_name: "MAC88",
    sub_provider_name: "Mac88 Gaming Virtual",
    status: "ACTIVE",
    url_thumb: newLaunch6,
    game_code: "MAC88-CVO101",
  },
  {
    src: newLaunch7,
    alt: "Deal Or No Deal",
    gameId: "151179",
    gameCode: "MAC88-CDRND101",
    gameName: "Deal Or No Deal",
    urlThumb: newLaunch7,
    category: "Virtual",
    providerName: "MAC88",
    subProviderName: "Mac88 Gaming Virtual",
    superProviderName: "",
    providerTag: "",
    priority: 0,
    game_id: "151179",
    game_name: "Deal Or No Deal",
    provider_name: "MAC88",
    sub_provider_name: "Mac88 Gaming Virtual",
    status: "ACTIVE",
    url_thumb: newLaunch7,
    game_code: "MAC88-CDRND101",
  },
  {
    src: newLaunch8,
    alt: "Snakes",
    gameId: "151170",
    gameCode: "MAC88-CSN101",
    gameName: "Snakes",
    urlThumb: newLaunch8,
    category: "Slot Games",
    providerName: "MAC88",
    subProviderName: "Mac88 Gaming Virtual",
    superProviderName: "",
    providerTag: "",
    priority: 0,
    game_id: "151170",
    game_name: "Snakes",
    provider_name: "MAC88",
    sub_provider_name: "Mac88 Gaming Virtual",
    status: "ACTIVE",
    url_thumb: newLaunch8,
    game_code: "MAC88-CSN101",
  },
  {
    src: newLaunch9,
    alt: "Pump",
    gameId: "151162",
    gameCode: "MAC88-CPUM101",
    gameName: "Pump",
    urlThumb: newLaunch9,
    category: "Virtual",
    providerName: "MAC88",
    subProviderName: "Mac88 Gaming Virtual",
    superProviderName: "",
    providerTag: "",
    priority: 0,
    game_id: "151162",
    game_name: "Pump",
    provider_name: "MAC88",
    sub_provider_name: "Mac88 Gaming Virtual",
    status: "ACTIVE",
    url_thumb: newLaunch9,
    game_code: "MAC88-CPUM101",
  },
  {
    src: newLaunch10,
    alt: "Cricket Battle",
    gameId: "151185",
    gameCode: "MAC88-XCRB101",
    gameName: "Cricket Battle",
    urlThumb: newLaunch10,
    category: "Virtual",
    providerName: "MAC88",
    subProviderName: "Mac88 Gaming Virtual",
    superProviderName: "",
    providerTag: "",
    priority: 0,
    game_id: "151185",
    game_name: "Cricket Battle",
    provider_name: "MAC88",
    sub_provider_name: "Mac88 Gaming Virtual",
    status: "ACTIVE",
    url_thumb: newLaunch10,
    game_code: "MAC88-XCRB101",
  },
  {
    src: newLaunch11,
    alt: "Volt Run",
    gameId: "151190",
    gameCode: "MAC88-CVR101",
    gameName: "Volt Run",
    urlThumb: newLaunch11,
    category: "Crash Game",
    providerName: "MAC88",
    subProviderName: "Mac88 Gaming Virtual",
    superProviderName: "",
    providerTag: "",
    priority: 0,
    game_id: "151190",
    game_name: "Volt Run",
    provider_name: "MAC88",
    sub_provider_name: "Mac88 Gaming Virtual",
    status: "ACTIVE",
    url_thumb: newLaunch11,
    game_code: "MAC88-CVR101",
  },
  {
    src: newLaunch12,
    alt: "Solitaire",
    gameId: "151183",
    gameCode: "MAC88-VTGSOL101",
    gameName: "Solitaire",
    urlThumb: newLaunch12,
    category: "Casual Games",
    providerName: "MAC88",
    subProviderName: "Mac88 Gaming Virtual",
    superProviderName: "",
    providerTag: "",
    priority: 0,
    game_id: "151183",
    game_name: "Solitaire",
    provider_name: "MAC88",
    sub_provider_name: "Mac88 Gaming Virtual",
    status: "ACTIVE",
    url_thumb: newLaunch12,
    game_code: "MAC88-VTGSOL101",
  },
];

export const CASINO_PROVIDER_IMAGES = [
  {
    src: casino1,
    path: "/casino?category=Mac88+Gaming+Virtual&providerCode=MAC88&subCategory=ALL",
  },
  {
    src: casino2,
    path: "/casino?category=Mac88+Gaming&providerCode=MAC88&subCategory=ALL",
  },
  {
    src: casino3,
    path: "/casino?category=MAC+Excite&providerCode=MAC88&subCategory=ALL",
  },
  {
    src: casino4,
    path: "/casino?category=EZUGI&providerCode=EZU&subCategory=ALL",
  },
  {
    src: casino5,
    path: "/casino?category=SMARTSOFT&providerCode=SMS&subCategory=ALL",
  },
  {
    src: casino6,
    path: "/casino?category=TURBO&providerCode=TRB&subCategory=ALL",
  },
  {
    src: casino7,
    path: "/casino?category=SPRIBE&providerCode=SPB&subCategory=ALL",
  },
  {
    src: casino8,
    path: "/casino?category=EVOLUTION&providerCode=EVO&subCategory=ALL",
  },
  {
    src: casino9,
    path: "/casino?category=JILI&providerCode=JIL&subCategory=ALL",
  },
  {
    src: casino10,
    path: "/casino?category=GAMZIX&providerCode=GZX&subCategory=ALL",
  },
  // {
  //   src: "https://speedcdn.io/frontend_config/tiger/images/17627667896330903.webp",
  //   path: "/casino?category=AE+SEXY&providerCode=SAG&subCategory=ALL",
  // },
  {
    src: casino11,
    path: "/casino?category=BetGames+TV&providerCode=BTV&subCategory=ALL",
  },
  {
    src: casino12,
    path: "/casino?category=Vivo+Gaming&providerCode=MAC88&subCategory=ALL",
  },
  {
    src: casino13,
    path: "/casino?category=Bombay+Live&providerCode=MAC88&subCategory=ALL",
  },
  {
    src: casino14,
    path: "/casino?category=Popok+Instant&providerCode=MAC88&subCategory=ALL",
  },
];
